// Components==============
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import './DraggableTile.module.scss';
// =========================

export default function DraggableTile({
    isDraggable,
    index,
    tileBarState,
    tilePartIsFinished,
    id,
}: {
    isDraggable: boolean;
    index: number;
    tileBarState: string[];
    tilePartIsFinished: boolean;
    id: string;
}) {
    if (isDraggable)
        return (
            <Draggable key={id} index={index} draggableId={id}>
                {(provided) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        styleName={`${tileBarState[index]
                            .split(' ')
                            .pop()} drag-tile`}
                    >
                        {tileBarState[index].includes('special-sound') && (
                            <div styleName="overlay" />
                        )}

                        {tileBarState[index] !== '' && (
                            <motion.div
                                styleName="delete"
                                whileHover={{ opacity: 1 }}
                                initial={{ opacity: 0 }}
                                style={{
                                    color: tileBarState[index].includes(
                                        'special-sound'
                                    )
                                        ? 'grey'
                                        : 'white',
                                }}
                            >
                                <FontAwesomeIcon icon={faPlus} />
                            </motion.div>
                        )}
                    </div>
                )}
            </Draggable>
        );
    if (!tilePartIsFinished) return <></>;

    return (
        <div styleName={` ${tileBarState[index].split(' ').pop()} drag-tile`}>
            {tileBarState[index].includes('special-sound') && (
                <div styleName="overlay" />
            )}
        </div>
    );
}
